import React, {Component} from 'react'
//import PropTypes from 'prop-types'

import './index.css'
import ControlBar from './ControlBar'
import BackBtn from './ic_class_back.svg'
import BigPlayButton from './BigPlayButton'
import {connect} from "react-redux";
import {Image} from "antd-mobile";

const HIDE_PAUSED_GROUP_FOR_CLICK = 3000;
class VideoPlayer extends Component {
  _controlBar
  _hideControlBarTimeoutId

  constructor(props) {
    super(props)
    this.state = {
      video: null,
      bigPlayBtnVisible: false,
      controlBarVisible: false,
      fullScreen:false
    }
  }


  render() {
    const {videoPlay} = this.props
    const {controlBarVisible,fullScreen} = this.state
    let fullScreen1 = false;
    const videoWidth = videoPlay && videoPlay.playInfoList&&videoPlay.playInfoList[0].width;
    const videoHeight = videoPlay && videoPlay.playInfoList&&videoPlay.playInfoList[0].height;
    if(videoWidth>videoHeight){
      fullScreen1 = true;
    }
    return (
      <div className={"videoPlayerContainer"}>

        {controlBarVisible &&  <img
                className="backBtn"
                src={BackBtn}
                alt="back"
                onClick={() =>this.props.history.push('/')}
            />
        }
        {/*{controlBarVisible &&*/}
        {/*<img*/}
        {/*  className="pauseBtn"*/}
        {/*  src={BackBtn}*/}
        {/*  alt="back"*/}
        {/*  onClick={this.handleClose}*/}
        {/*/>*/}
        {/*}*/}


        <video
          className={"video"}
          //src={videoPlay && videoPlay.playInfoList&&videoPlay.playInfoList[0].playURL}
          //poster={(videoPlay && videoPlay.playInfoList&&videoPlay.playInfoList[0].playURL) || null}
          playsInline
          autoplay='autoplay'
          autoplayNew='autoplay'
          preload="load"
          airplay="allow"
          x5-playsinline="true"
          x-webkit-airplay="allow"
          x5-video-player-type="h5"
          webkit-playsinline="true"
          ref={this.handleVideoRef}
          onClick={this.handleVideoClick}
          onProgress={this.handleVideoProgress}

        >
          {videoPlay?.playInfoList.map((item, index) => (
              <source src={item.playURL}/>
          ))}


        </video>
        <BigPlayButton ctx={this} />
        <ControlBar ctx={this} ref={e => e && (this._controlBar = e)} />
      </div>
    )
  }

  componentWillUnmount() {
    const {_hideControlBarTimeoutId} = this
    clearTimeout(_hideControlBarTimeoutId)
  }

  handleVideoRef = video => {
    this.setState({video})
  }

  handleVideoClick = () => {
    const {controlBarVisible, video, bigPlayBtnVisible} = this.state
    if (!video) return
    // 播放状态可以显示隐藏控制栏
    if (!bigPlayBtnVisible) {
      if (controlBarVisible) {
        this.hideControlBar()
      } else {
        this.showControlBar(false)
        this.handleClose();
      }
    }
  }

  handleVideoProgress = () => {
    this.forceUpdate()
  }

  toggleBigPlayBtn = () => {
    const {bigPlayBtnVisible} = this.state
    this.setState({bigPlayBtnVisible: !bigPlayBtnVisible})
  }
  toggleFullScreen = () => {
    const {fullScreen} = this.state
    this.setState({fullScreen: !fullScreen})
  }

  showControlBar = (autoHide = true) => {
    const {_hideControlBarTimeoutId} = this
    clearTimeout(_hideControlBarTimeoutId)
    this.setState({
      controlBarVisible: true
    })
    if (autoHide)
      this._hideControlBarTimeoutId = setTimeout(
        this.hideControlBar,
        HIDE_PAUSED_GROUP_FOR_CLICK
      )
  }

  hideControlBar = () => {
    const {_hideControlBarTimeoutId} = this
    clearTimeout(_hideControlBarTimeoutId)
    this.setState({
      controlBarVisible: false
    })
  }

  play = () => {
    const {video} = this.state
    if (!video) return
    video.play()
    // 控制条按钮为暂停样式
    this._controlBar.togglePlayBtn('pause')
  }

  pause = () => {
    const {video} = this.state
    if (!video) return
    video.pause()
    this._controlBar.togglePlayBtn('play')
  }

  replay = () => {
    const {video} = this.state
    if (!video) return
    video.currentTime = 0
    this.play()
  }

  // 点击左上角退出按钮
  handleClose = () => {
    //this.hideControlBar()
    this.toggleBigPlayBtn()
    this.pause()
  }
}

// VideoPlayer.propTypes = {
//   data: PropTypes.object.isRequired,
// }
const mapState = state => {
  return {
    videoPlay:state.getIn(['videoPlay', 'videoPlay'])
  }
}

const mapDispatch = dispatch => {
  return {

  }
}

export default connect(mapState, mapDispatch)(VideoPlayer)
